import React from 'react';
import { Helmet } from 'react-helmet';
import config from '../../config/SiteConfig';

export default ({ title, desc, canUrl, tag, img }) => (
	<Helmet>
		<title>{title || config.title}</title>
		<meta charSet="utf-8" />
		<meta httpEquiv="x-ua-compatible" content="ie=edge" />
		<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
		<meta name="description" content={desc || config.description} />
		<link rel="publisher" href="https://plus.google.com/+AhmadAwais" />
		<meta property="og:locale" content="en_US" />
		<meta property="og:type" content="website" />
		<meta property="og:title" content={title || config.title} />
		<meta property="og:description" content={desc || config.description} />
		<meta property="og:url" content={config.url} />
		<meta property="og:site_name" content={title || config.title} />
		<meta property="article:author" content="http://facebook.com/ahmadawais" />
		<meta property="article:publisher" content="https://www.facebook.com/mrahmadawais" />
		<meta property="article:section" content="VSCode" />
		<meta name="image" content={img || config.featuredImage} />
		<meta itemprop="image" content={img || config.featuredImage} />
		<meta property="og:image" content={img || config.featuredImage} />
		<meta property="og:image:secure_url" content={img || config.featuredImage} />
		<meta property="og:image:width" content="1200" />
		<meta property="og:image:height" content="630" />
		<meta name="twitter:card" content="summary_large_image" />
		<meta name="twitter:site" content={config.twitterHandle} />
		<meta name="twitter:creator" content={config.twitterHandle} />
		<meta name="twitter:title" content={title || config.title} />
		<meta name="twitter:image" content={img || config.featuredImage} />
		<meta name="twitter:image:1200" content={img || config.featuredImage} />
		<meta name="twitter:image:630" content={img || config.featuredImage} />
		<meta name="twitter:description" content={desc || config.description} />
		<meta name="twitter:image" content={img || config.featuredImage} />
		<meta name="twitter:url" content={config.url} />
		<meta name="twitter:image:alt" content={title || config.title} />
		<meta property="article:tag" content={tag && tag} />
		<meta property="article:tag" content="Visual Studio Code" />
		<meta property="article:tag" content="Visual Studio Code Power Developer" />
		<meta property="article:tag" content="Visual Studio Code Power User" />
		<meta property="article:tag" content="VSCode Power User" />
		<meta property="article:tag" content="Learn VSCode" />
		<meta name="google-site-verification" content="rXpyxArS7NgpUGSagiy7BxzNtVCep4aKi8CJVVapByY" />
		<link rel="dns-prefetch" href="https://www.google-analytics.com" crossOrigin="anonymous" />
		<link rel="preconnect" href="https://api.ipstack.com" crossOrigin="anonymous" />
		<link rel="preconnect" href="https://widget.intercom.io" crossOrigin="anonymous" />
	</Helmet>
);
